import React from 'react';
import { MapContainer, TileLayer, CircleMarker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { useTheme } from '@mui/material';

// Fleet map fed directly by dashboard data (correct online pins, theme-aware).
const FleetMap = ({ devices = [], height = 360 }) => {
  const theme = useTheme();
  const pts = devices.filter((d) => d.latitude && d.longitude);
  const center = pts.length ? [pts[0].latitude, pts[0].longitude] : [20.5937, 78.9629];
  const tileUrl = theme.palette.mode === 'dark'
    ? 'https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png'
    : 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png';
  const online = theme.palette.success.main;
  const offline = theme.palette.text.disabled;

  return (
    <MapContainer center={center} zoom={5} style={{ height, width: '100%', borderRadius: 12, background: theme.palette.background.default }}>
      <TileLayer
        attribution='&copy; OpenStreetMap &copy; CARTO'
        url={tileUrl}
      />
      {pts.map((d) => (
        <CircleMarker
          key={d.deviceId}
          center={[d.latitude, d.longitude]}
          radius={7}
          pathOptions={{
            color: d.online ? online : offline,
            fillColor: d.online ? online : offline,
            fillOpacity: 0.85, weight: 2,
          }}
        >
          <Popup>
            <strong>{d.name}</strong><br />
            {d.deviceId}<br />
            {d.online ? `Online · ${d.link === '4g' ? '4G' : 'WiFi'}` : 'Offline'}<br />
            {d.tests} tests
          </Popup>
        </CircleMarker>
      ))}
    </MapContainer>
  );
};

export default FleetMap;
